// International phone helpers (E.164 friendly).
// Students join from India, Nepal, Bangladesh, Sri Lanka, Nigeria, Vietnam, the US, etc.
// We store numbers in E.164 (`+<country><subscriber>`) and strip everything but
// digits when building WhatsApp deep links.

/** Digits only, keeping the leading country code. Safe for null/undefined. */
export function waDigits(raw: unknown): string {
  const s = typeof raw === "string" ? raw : raw == null ? "" : String(raw);
  const digits = s.replace(/\D/g, "");
  if (!digits) return "";
  // Legacy Indian local formats stored without a country code.
  if (digits.length === 10) return `91${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `91${digits.slice(1)}`;
  // Strip international dialling prefix "00" (e.g. 0091..., 00977...).
  if (digits.length > 11 && digits.startsWith("00")) return digits.slice(2);
  return digits;
}

/** Normalize any user input to E.164, defaulting bare 10-digit numbers to +91. */
export function toE164(raw: unknown): string {
  const digits = waDigits(raw);
  return digits ? `+${digits}` : "";
}

/** Loose validity check that accepts any country code (7-15 digits per E.164). */
export function isValidInternationalPhone(raw: unknown): boolean {
  const digits = waDigits(raw);
  return digits.length >= 8 && digits.length <= 15;
}

/** Build a WhatsApp deep link; returns "" when there is no usable number. */
export function buildWhatsAppUrl(rawPhone: unknown, message: string): string {
  const digits = waDigits(rawPhone);
  if (!digits) return "";
  return `https://wa.me/${digits}?text=${encodeURIComponent(message ?? "")}`;
}
